import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { Paragraph } from '../../../styles/paragraph';
import BasketItemSize from '../BasketItemSize';

const gwpPromo = config.get('public.promoCodes.giftWithPurchase');

const ItemDetails = styled.div``;

const ItemData = styled(Paragraph).attrs({ size: 12 })`
  font-weight: normal;
  ${(props) =>
    props.theme.context?.cartDrawer &&
    props.hideInDrawer &&
    `
    display: none;
  `};
`;

const BasketPricePromo = styled(Paragraph)`
  flex: 1 1 auto;
  ${(props) =>
    props.theme.context?.cartDrawer &&
    props.hideInDrawer &&
    `
    display: none;
  `};
  color: ${(props) =>
    props.isClearanceItem
      ? props.theme.colors.basketPricePromoClearance
      : props.theme.colors.electricViolet};
  font-size: 12px;
`;

const TextWrapper = styled.span`
  color: ${({ theme }) => theme.colors.textFadedAlternate};
`;

const BasketItemDetails = ({
  className,
  discounts,
  hideColor,
  hideDetails,
  isClearanceItem,
  isExchange,
  isHeader,
  isMysteryBox,
  product,
  renderDetails,
}) => {
  const renderColor = (product) => {
    if (hideColor) {
      return null;
    }

    // FIXME Temporary fix for order confirmation
    const colorMatch = product.alias && product.alias.match(/\(([^)]+)\)/);
    const color = product.color || (colorMatch && colorMatch[1]);
    return (
      <ItemData hideInDrawer>
        <TextWrapper>
          <FormattedMessage
            id="global_checkout.color_label"
            defaultMessage="Color"
          />
        </TextWrapper>
        {': '}
        {isMysteryBox ? (
          <FormattedMessage
            id="global_checkout.mystery_box_color_label"
            defaultMessage="Assorted"
          />
        ) : (
          color
        )}
      </ItemData>
    );
  };

  if (hideDetails) {
    return null;
  }

  if (renderDetails) {
    return renderDetails(product);
  }

  const promo = discounts && discounts.length > 0;
  const promoLabel = promo
    ? discounts[0].promoLabel || discounts[0].label
    : null;

  const isGwpProduct =
    product.discount && product.discount.promoCode === gwpPromo.promoCode;

  return (
    <ItemDetails className={className}>
      {promo && isHeader && !isGwpProduct ? (
        <BasketPricePromo hideInDrawer isClearanceItem={isClearanceItem}>
          {promoLabel}
        </BasketPricePromo>
      ) : null}
      <ItemData>
        <BasketItemSize
          isExchange={isExchange}
          product={product}
          isMysteryBox={isMysteryBox}
        />
      </ItemData>
      {renderColor(product)}
    </ItemDetails>
  );
};

BasketItemDetails.propTypes = {
  className: PropTypes.string,
  discounts: PropTypes.number,
  hideColor: PropTypes.bool,
  hideDetails: PropTypes.bool,
  isClearanceItem: PropTypes.bool,
  /**
   * Prop passed into  BasketItemSize
   */
  isExchange: PropTypes.bool,
  isHeader: PropTypes.bool,
  /**
   * Prop passed into  BasketItemSize
   */
  isMysteryBox: PropTypes.bool,
  product: PropTypes.object.isRequired,
  renderDetails: PropTypes.func,
};

BasketItemDetails.defaultProps = {};

export default BasketItemDetails;
